
export const type= 'GET-RELATED-RECIPES'
const GetRelatedRecipes = ()=>({
    type
})
export default GetRelatedRecipes